import qs from 'qs'

/**
 * config.timeout超时时间
 * config.withCredentials是否提供凭据信息
 *
 */
class $Http {
  constructor() {
    this.config = {}
    this.method = 'GET'
    this.data = null
  }
  $config(config = {}) {
    this.config = config
    return this
  }
  $get(url, data) {
    var actureData = Object.assign({client:'pc_browser',package_check: 'peter'}, data || {})
    let dataStr = qs.stringify(actureData)
    return this.ajax(`${url}?${dataStr}`)
  }
  $post(url, data = {}) {
    var actureData = Object.assign({client:'pc_browser',package_check: 'peter'},data)
    this.method = 'POST'
    this.config.headers = Object.assign({}, this.config.headers, {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    })
    this.data = qs.stringify(actureData)
    return this.ajax(url,data)
  }
  ajax(url,data={}) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      // xhr.responseType = this.config.withCredentials || 'json'
      xhr.open(this.method, url, true)
      // xhr.withCredentials = this.config.withCredentials || false
      // xhr.timeout = this.config.timeout * 1000 || 20000
      let _h = this.config.headers
      if (_h) {
        Object.keys(_h).forEach(key => {
          xhr.setRequestHeader(key, _h[key])
        })
      }
      xhr.send(this.data)
      xhr.onload = e => {
        // let res = xhr.responseText
        let res = JSON.parse(xhr.responseText)
        if (res.code && res.code !== 200) {
          console.log(`%c ${res.msg}`, 'color:red')
        }
        resolve(res)
      }
      xhr.ontimeout = xhr.onerror = e => {
        console.log(`%c ${JSON.stringify(e)}`, 'color:red')
        reject(e)
      }
    })
  }
}

export default {
  $config: function(config) {
    let http = new $Http(this)
    return http.$config(config)
  },
  $get: function(url, data) {
    let http = new $Http(this)
    return http.$get(url, data)
  },
  $post: function(url, data) {
    let http = new $Http(this)
    return http.$post(url, data)
  }
}
